import ApiFactory from '@/factories/ApiFactory'
import {serialize} from '@/utilities/querySerialize'

export default {
  list (query) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/users?${serialize(query)}&include=roles`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  roles () {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/users/actions/getRoles`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  details (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/users/${id}?include=roles`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/users', payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  update (payload) {
    return new Promise((resolve, reject) => {
      let id = payload.id
      ApiFactory.put(`v1/users/${id}`, payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.delete(`v1/users/${id}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  enable (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.put(`v1/users/${id}/actions/enable`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  disable (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.delete(`v1/users/${id}/actions/disable`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  downloadExcelExample: () => {
    return new Promise((resolve, reject) => {
      ApiFactory({
        url: `v1/users/actions/downloadExcelExample`,
        method: 'GET',
        responseType: 'blob'
      }).then(
        (success) => {
          const url = window.URL.createObjectURL(new Blob([success.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'users_import_example.xlsx');
          document.body.appendChild(link);
          link.click();
          resolve()
        },
        (error) => reject(error)
      );
    });
  },
  getProjects (userId, query) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/users/${userId}/actions/getProjects?${serialize(query)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  getConfigurations (userId) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/users/${userId}/actions/getConfigurations`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  updateConfigurations (userId, configs) {
    return new Promise((resolve, reject) => {
      ApiFactory.put(`v1/users/${userId}/actions/updateConfigurations`, configs)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  getPTOLogs (userId) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/users/${userId}/actions/getPtoLogs?include=transactions`)
        .then(
          (success) => resolve(success.data.data),
          (error) => reject(error)
        )
    })
  },
}
